import classNames from 'classnames';
import { ComponentProps } from 'react';
import { PopoverMenu } from 'app/agriculture/components/PopoverMenu/PopoverMenu';
import { Button } from 'app/agriculture/components/Button/Button';
import './Actions.scss';

interface ActionsProps {
    primaryAction?: ComponentProps<typeof Button>;
    backAction?: ComponentProps<typeof Button>;
    secondaryActions?: ComponentProps<typeof Button>[];
    sticky?: boolean;
}

export function Actions({
    primaryAction,
    backAction,
    secondaryActions = [],
    sticky = false,
}: ActionsProps) {
    return (
        <div className={classNames('Actions', { 'Actions--sticky': sticky })}>
            {backAction && (
                <Button
                    startIcon="back"
                    variant="textonly"
                    {...backAction}
                    className={classNames(backAction.className, 'Actions__back-action')}
                />
            )}

            {secondaryActions.length === 0 ? null : (
                <PopoverMenu
                    trigger={{ text: 'Actions', variant: 'textonly' }}
                    items={secondaryActions}
                />
            )}

            {primaryAction && (
                <Button
                    {...primaryAction}
                    className={primaryAction.className}
                    variant="contained"
                />
            )}
        </div>
    );
}
